import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import "./log_sing.css";
import LongInFrom from "./LongInFrom";
const Login_page = () => {
  return (
    <div>
      <Header></Header>

      <LongInFrom></LongInFrom>

      <Footer></Footer>
    </div>
  );
};

export default Login_page;
